import React, { useState, useEffect } from 'react';
import { getGallery } from '../services/api';

const Galerie = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const data = await getGallery();
        setGallery(data);
      } catch (error) {
        console.error('Error loading gallery:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchGallery();
  }, []);

  const categories = ['Tous', ...new Set(gallery.map(item => item.category))];

  const filteredGallery = selectedCategory === 'Tous' 
    ? gallery 
    : gallery.filter(item => item.category === selectedCategory);

  if (loading) {
    return (
      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
        <p className="body-large">Chargement de la galerie...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <section 
        style={{
          position: 'relative',
          height: '50vh',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          background: 'var(--bg-secondary)'
        }}
      >
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url(https://images.unsplash.com/photo-1626383137804-ff908d2753a2)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.5)'
          }}
        />
        
        <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: '1400px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-large" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
            Notre Galerie
          </h1>
          <p className="body-large" style={{ color: 'var(--bg-primary)' }}>
            Découvrez notre institut et nos réalisations
          </p>
        </div>
      </section>

      {/* Filtres */}
      <section style={{ background: 'var(--bg-primary)', padding: '40px 0' }}>
        <div className="container">
          <div style={{ 
            display: 'flex', 
            gap: '16px', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            borderBottom: '1px solid var(--border-light)',
            paddingBottom: '16px'
          }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className="navigation-text"
                style={{
                  padding: '12px 24px',
                  background: selectedCategory === category ? 'var(--interactive-base)' : 'transparent',
                  color: selectedCategory === category ? 'var(--bg-primary)' : 'var(--text-primary)',
                  border: '1px solid var(--border-medium)',
                  borderRadius: '0px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  fontSize: '14px',
                  fontWeight: selectedCategory === category ? 700 : 400
                }}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Grille de photos */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: window.innerWidth >= 1024 ? 'repeat(3, 1fr)' : window.innerWidth >= 768 ? 'repeat(2, 1fr)' : '1fr',
            gap: '32px'
          }}>
            {filteredGallery.map((item) => (
              <div 
                key={item.id}
                className="hover-lift"
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  aspectRatio: '1',
                  cursor: 'pointer',
                  borderRadius: '0px'
                }}
              >
                <img 
                  src={item.image} 
                  alt={item.title} 
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                />
                <div 
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '24px',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                    color: 'var(--bg-primary)'
                  }}
                >
                  <h3 className="heading-3" style={{ color: 'var(--bg-primary)', marginBottom: '4px' }}>
                    {item.title}
                  </h3>
                  <p className="body-small" style={{ color: '#C9A961' }}>
                    {item.category}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Réseaux Sociaux */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            Suivez-nous sur les réseaux sociaux
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Restez informée de nos nouveautés, offres spéciales, photos de l'institut et inspirations beauté
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a 
              href="https://www.facebook.com/ninacareinstitut" 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Facebook
            </a>
            <a 
              href="https://www.instagram.com/ninacareinstitut" 
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Instagram
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Galerie;
